<div appTheme>
    <router-outlet></router-outlet>
</div>
